import { render, staticRenderFns } from "./bim.vue?vue&type=template&id=05375aee&scoped=true"
import script from "./bim.vue?vue&type=script&lang=js"
export * from "./bim.vue?vue&type=script&lang=js"
import style0 from "./bim.vue?vue&type=style&index=0&id=05375aee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05375aee",
  null
  
)

export default component.exports